/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  makeStyles,
  TextField,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faUserCog } from "@fortawesome/pro-solid-svg-icons";
import { Person } from "@material-ui/icons";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  dialogContent: {
    width: "800px",
  },
  title: {
    fontSize: "20px",
    color: "#222222",
  },
  subHeading: {
    fontSize: "17px",
    color: "#707071",
    fontWeight: "normal",
  },
  cancelBtn: {
    color: "#3582F6",
  },
  actionBtn: {
    color: "#F73636",
  },
  textField: {
    marginTop: "5px",
    borderRadius: "5px",
    // border: "1px solid #707070",
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        border: "1px solid #707070",
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #707070",
      },
    },
  },
}));

const MuiDialog = ({
  data,
  open,
  onSuccess,
  onClose,
  type,
  title,
  menu,
  newPassword,
  setNewPassword,
  setIsReset,
  rest,
}) => {
  const classes = useStyles();
  console.log("ddd", data);
  const [showPassword, setshowPassword] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState("");
  const [repeatpassword, setrepeatpassword] = useState(false);
  const [disable, setdisable] = useState(false);

  const handleSubmit = () => {
    if (type === "delete") {
      onSuccess(true);
      onClose(false);
    }
    if (type === "reset") {
      onClose(false);
      setIsReset(true);
    } else {
      onClose(false);
    }
  };
  const handleClose = () => {
    onClose(false);
    if (type === "reset") {
      setNewPassword("");
    }
  };

  useEffect(() => {
    if (newPassword !== "" && confirmPassword !== "") {
      setdisable(false);
    } else {
      setdisable(true);
    }
    if (newPassword !== confirmPassword) {
      setdisable(true);
    }
  }, [confirmPassword]);
  return (
    <Dialog open={open} maxWidth="md">
      <DialogTitle style={{ margin: "0px", paddingBottom: "0px" }}>
        <h3 className={classes.title}>{title}</h3>
        <p className={classes.subHeading}>
          This action cannot be reversed. Are you sure you want to continue?
        </p>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div
          data-testid="dialog"
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #3683F7",
            borderRadius: "5px",
            padding: "10px",
          }}
        >
          <div
            style={{
              width: "80px",
              height: "80px",
              // background: "#00000029",
              borderRadius: "5px",
              marginRight: "10px",
            }}
          >
            {" "}
            {menu === "users" ? (
              <Person
                style={{ width: "100%", height: "100%", color: "#00000059" }}
              />
            ) : menu === "groups" ? (
              <FontAwesomeIcon
                icon={faUsers}
                style={{
                  width: "100%",
                  height: "100%",
                  color: "#00000059",
                }}
              />
            ) : menu === "roles" ? (
              <FontAwesomeIcon
                icon={faUserCog}
                style={{
                  width: "100%",
                  height: "100%",
                  color: "#00000059",
                }}
              />
            ) : null}
          </div>
          <div>
            <div
              style={{
                color: "#222222",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              {data?.name ? data?.name : "Unknown"}
              <br />
              {menu === "users" && (
                <span
                  style={{
                    color: "#707070",
                    fontWeight: "normal",
                    fontSize: "17px",
                  }}
                >
                  {data?.email}
                </span>
              )}
            </div>
          </div>
        </div>
        {type === "reset" && (
          <div>
            <TextField
              // autoFocus
              size="small"
              placeholder="New Password"
              autoComplete="new-password"
              variant="outlined"
              type={showPassword ? "text" : "password"}
              fullWidth
              className={classes.textField}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              helperText={newPassword === "" ? "* This Field is Required" : ""}
              error={newPassword === "" ? true : false}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      style={{ background: "none" }}
                      edge="end"
                      disableRipple={true}
                      onClick={() => {
                        setshowPassword(true);
                      }}
                      onMouseDown={() => {
                        setshowPassword(false);
                      }}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              // autoFocus
              size="small"
              placeholder="Repeat Password"
              variant="outlined"
              autoComplete="off"
              type={repeatpassword ? "text" : "password"}
              fullWidth
              className={classes.textField}
              value={confirmPassword}
              onChange={(e) => setconfirmPassword(e.target.value)}
              helperText={
                confirmPassword === ""
                  ? "* This Field is Required"
                  : newPassword !== confirmPassword
                  ? "* Password must be same"
                  : ""
              }
              error={
                confirmPassword === "" || newPassword !== confirmPassword
                  ? true
                  : false
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      style={{ background: "none" }}
                      edge="end"
                      disableRipple={true}
                      onClick={() => {
                        setrepeatpassword(true);
                      }}
                      onMouseDown={() => {
                        setrepeatpassword(false);
                      }}
                    >
                      {repeatpassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        )}
      </DialogContent>
      <DialogActions style={{ paddingTop: "20px", paddingRight: "20px" }}>
        <Button className={classes.cancelBtn} onClick={handleClose}>
          CANCEL
        </Button>
        {type === "reset" ? (
          <Button
            className={classes.actionBtn}
            style={{ color: disable ? "#62666e" : "#F73636" }}
            type="submit"
            onClick={handleSubmit}
            disabled={disable}
          >
            RESET
          </Button>
        ) : (
          <Button
            className={classes.actionBtn}
            type="submit"
            onClick={handleSubmit}
          >
            DELETE
          </Button>
        )}
        {/* <Button
          className={classes.actionBtn}
          type="submit"
          onClick={handleSubmit}
        >
          {type === "reset" ? "RESET" : "DELETE"}
        </Button> */}
      </DialogActions>
    </Dialog>
  );
};

export default MuiDialog;
